export function isEmptyDoc(doc) {
    var _a, _b;
    return !!(doc.childCount === 1 &&
        ((_a = doc.firstChild) === null || _a === void 0 ? void 0 : _a.type.name) === 'paragraph' &&
        ((_b = doc.firstChild) === null || _b === void 0 ? void 0 : _b.childCount) === 0);
}
//# sourceMappingURL=doc.js.map